import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { theme } from './theme/theme';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
import { NotificationProvider } from './components/NotificationProvider';
import { ProcessingToast } from './components/ProcessingToast';
import LoginPage from './pages/LoginPage';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import UploadPage from './pages/UploadPage';
import ResultPage from './pages/ResultPage';
import ListReceiptsPage from './pages/ListReceiptsPage';
import ReceiptDetailPage from './pages/ReceiptDetailPage';
import ReportsPage from './pages/ReportsPage';
import ManualReceiptPage from './pages/ManualReceiptPage';
import DescriptionManagerPage from './pages/DescriptionManagerPage';
import ShoppingListsPage from './pages/ShoppingListsPage';
import LinkedReceiptsPage from './pages/LinkedReceiptsPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider>
          <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/callback" element={<OAuthCallbackPage />} />
            {/* Legacy OAuth callback routes (for backwards compatibility) */}
            <Route path="/oauth/google/callback" element={<OAuthCallbackPage />} />
            <Route path="/oauth/microsoft/callback" element={<OAuthCallbackPage />} />

            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <ReportsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <UploadPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/result"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <ResultPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/receipts"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <ListReceiptsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/receipts/new"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <ManualReceiptPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/receipt/:receiptId"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <ReceiptDetailPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/descriptions"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <DescriptionManagerPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/lists"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <ShoppingListsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/lists/completed"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <LinkedReceiptsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
          <NotificationProvider />
          <ProcessingToast />
          </BrowserRouter>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
